import { render, staticRenderFns } from "./settings-account-phone-calls.vue?vue&type=template&id=0fbca6b3&scoped=true&"
import script from "./settings-account-phone-calls.vue?vue&type=script&lang=js&"
export * from "./settings-account-phone-calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbca6b3",
  null
  
)

export default component.exports